import axios from 'axios';
import Vue from 'vue'

export default {

    findAllPartner (minLat,maxLat,minLon,maxLon,zoomLevel ) {
        return axios.get('/api/partner/list-clustered', {params: {minLat:minLat, maxLat:maxLat, minLon:minLon, maxLon:maxLon, zoomLevel:zoomLevel}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getNearOptions ( ) {
        return axios.get('/api/partner/near-options')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deletePartner (page, pageSize, partnerId) {
        return axios.get('/api/partner/delete-partner', {params:{page: page, pageSize: pageSize, partnerId:partnerId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    
    findPartner(page, pageSize, filterRequestDTO) {
        return axios.post('/api/partner/all-partner',filterRequestDTO, { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSelectedPartners(page, pageSize, partnerFilter, campaignId, showOnlySelected) {
        return axios.get('/api/partner/selected',{ params: {page: page, pageSize: pageSize, partnerFilter:partnerFilter , campaignId:campaignId, showOnlySelected:showOnlySelected} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    editSelection(page, pageSize, partnerFilter, campaignId, partnerId, showOnlySelected) {
        return axios.get('/api/partner/change/selection',{ params: {page: page, pageSize: pageSize, partnerFilter:partnerFilter , campaignId:campaignId, partnerId:partnerId, showOnlySelected:showOnlySelected} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

        
    findPartnerById(partnerId) {
        return axios.get('/api/partner/id', { params: {partnerId: partnerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getCountLastRequestQuote() {
        return axios.get('/api/partner/count/quote')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    requestAddPartner(partner) {
        return axios.post('/api/partner/request-add-partner', partner)
        .then(response => {
            if (response && response.data) 
            Vue.prototype.$snotify.success("Votre demande a été bien envoyée")
                return response.data
        })
        .catch(error => {
            const processedError = error.includes('|') 
            ? error.split('|')[0].trim() 
            : error.trim();
        
            Vue.prototype.$snotify.error(processedError);
        })
    },


    addPartner(partner) {

        return axios.post('/api/partner/add-partner', partner)
        .then(response => {
            if (response && response.data) 
            Vue.prototype.$snotify.success("Partenaire enregistré avec succès")
                return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    importPartnersCsv(formData){
        return axios.post('/api/partner/import-partners', formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
            Vue.prototype.$snotify.success("Import des partners terminé");
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findAllPartnerStatus() {
        return axios.get('/api/partner/all-partner-status')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findAllPartnerNear(page, pageSize) {
        return axios.get('/api/partner/all-partner-near', { params: {page: page, pageSize:pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    savePartnerNear(page, pageSize , partnerNear) {
        return axios.post('/api/partner/save/partner-near', partnerNear, { params: {page: page, pageSize:pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deletePartnerNear(page, pageSize , partnerNearId) {
        return axios.get('/api/partner/delete/partner-near',{ params: {page: page, pageSize:pageSize, partnerNearId:partnerNearId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



}

